import { countries, expandedStates } from "../constants/data";
import { yesNoUnsure } from "../constants/options";

export const countryToCode = (country) =>
  countries.find((item) => item.name === country)?.code;

export const stateCodeToName = (abbr) =>
  expandedStates.find((item) => item.Abbr === abbr)?.state;

export const stateNameToCode = (state) =>
  expandedStates.find(item => item.state === state)?.Abbr;

export const nameIsBlank = (person) =>
  !person.firstName?.value?.trim() && !person.lastName?.value?.trim();

export const concatenateName = (person) => {
  if (person.firstName.value && person.lastName.value) {
    return `${person.firstName.value} ${person.lastName.value}`;
  } else if (person.firstName.value) {
    return person.firstName.value;
  } else if (person.lastName.value) {
    return person.lastName.value;
  } else {
    return "";
  }
};

export const nullNotBlankName = (person) => {
  return {
    ...person,
    firstName: person.firstName || null,
    lastName: person.lastName || null,
  };
};

export const booleanToText = (tOrF) => {
  return tOrF ? "Yes" : "No";
}

export const textToBoolean = (value) => 
  value === yesNoUnsure[0].value ? true : false;

export const copyNestedObj = (obj) => {
  const copy = {};
  for (let key in obj) {
    copy[key] = {...obj[key]};
  }
  return copy;
};

export const copyNestedObjArray = (array) => {
  return array.map(item => copyNestedObj(item));
};

export const timeToMS = (time) => {
    const hours = time.substring(0, 2);
    const minutes = time.substring(3, 5);
    const seconds = time.substring(6);
    return (hours * 3600000) + (minutes * 60000) + (seconds * 1000);
};//time is in hh:mm:ss format
